module.exports = __webpack_public_path__ + "static/media/benefit-management-green.009702e5.svg";